

export const veo = {
    tabs: {
      textToVideo: '文字转视频',
      imageToVideo: '图片转视频',
      referenceToVideo: '参考图转视频'
    },
    preview: {
      emptyTitle: '尚未生成视频',
      emptyDesc: '输入提示并点击生成，体验关键帧控制与原生音频能力',
      hint: '支持文字转视频、图片转视频与参考图转视频',
      resultLabel: '已生成',
      download: '下载',
      loadingNew: '正在生成视频...',
      loadingRegenerate: '正在重新生成视频...'
    },
    common: {
      prompt: '提示词',
      promptPlaceholder: "描述你的视频，例如：『慢动作的小猫玩毛线球，电影级打光，4K 画质』",
      model: '模型',
      fastMode: '快速模式',
      qualityMode: '高质量模式',
      aspectRatio: '画面比例',
      aspect169: '16:9 高清',
      aspect916: '9:16',
      aspectAuto: '自动',
      advancedOptions: '高级选项',
      watermark: '水印',
      watermarkPlaceholder: '输入文字水印…',
      randomSeed: '随机种子',
      seedPlaceholder: '10000 - 99999',
      seedDesc: '相同种子会生成相似视频；留空则自动分配',
      autoTranslate: '自动翻译提示词',
      autoTranslateDesc: '提示词将自动翻译为英文',
      creditsBar: '积分消耗',
      creditsValue: '{count} 积分',
      generateButton: '生成视频（{count} 积分）',
      promptRequired: '请输入提示词',
      promptAndImageRequired: '请上传图片并输入提示词',
      promptAndStartEndRequired: '请上传起始帧与结束帧并输入提示词',
      promptAndReferenceRequired: '请上传参考图片并输入提示词',
      requestFailed: '生成请求失败',
      pollingTimeout: '生成超时',
      pollingFailed: '生成失败：{msg}'
      ,
      errorTitle: '生成错误'
    },
    upload: {
      clickOrDrag: '点击或拖拽以上传',
      uploadTitle: '上传参考图片',
      formats: '支持 JPEG、PNG、WebP • 最大 10MB',
      selectedCount: '{count}/3 张已选',
      imagesCount: '{count}/3 张'
    },
    reference: {
      info: '参考图转视频仅支持快速模式和 16:9 比例。上传 1–3 张参考图片以引导生成。'
    },
    keyframe: {
      title: '关键帧模式',
      info: '可精确控制视频的起始与结尾帧，使用关键帧打造平滑过渡并保持叙事流畅。',
      start: '起始帧',
      end: '结束帧',
      imageFormats: 'JPG、PNG、WebP • 最大 10MB'
    }
  };
